import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, isRef as _isRef, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "account"
}
const _hoisted_2 = { class: "grid-block account-balance" }
const _hoisted_3 = { class: "account-balance__title" }
const _hoisted_4 = { class: "caption-medium--bold" }
const _hoisted_5 = { class: "account-balance__value" }
const _hoisted_6 = { class: "h1" }
const _hoisted_7 = { class: "account-balance__btn" }
const _hoisted_8 = { class: "grid-block account-tariff" }
const _hoisted_9 = { class: "account-history--title" }
const _hoisted_10 = { class: "h4 color-text-primary" }
const _hoisted_11 = { class: "account-history--link" }
const _hoisted_12 = {
  key: 0,
  class: "grid-block account-bottom"
}
const _hoisted_13 = { class: "grid-block account-services" }
const _hoisted_14 = { class: "account-services__title" }
const _hoisted_15 = { class: "h3" }
const _hoisted_16 = { class: "account-services__body" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "account-services__body-item_title" }
const _hoisted_19 = { class: "h4 color-text-primary" }
const _hoisted_20 = {
  key: 1,
  class: "details"
}
const _hoisted_21 = { class: "details-header" }

import { useAccount } from "@/composables/account/useAccount";
import { useI18n } from "vue-i18n";
import BaseFeedback from "@/components/base/BaseFeedback.vue";
import AddonsDetails from "@/components/addons/AddonsDetails.vue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { useRouter } from "vue-router";
import BaseButton from "@/components/base/BaseButton.vue";
import TariffMain from "@/components/tariff/TariffMain.vue";
import AddonsMain from "@/components/addons/AddonsMain.vue";
import BaseModal from "@/components/base/BaseModal.vue";
import AccountSkeleton from "@/components/account/AccountSkeleton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Account',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const {
  addonOptions,
  chosenAddon,
  closeFeedbackResultModal,
  discountPercent,
  discountName,
  disableAddon,
  enabledOptions,
  errorModal,
  feedbackModal,
  feedbackResult,
  feedbackResultModal,
  handleFeedbackSubmitResult,
  isAddonDetails,
  isLoading,
  nextPaymentDate,
  openAddonDetails,
  pricePeriodLabel,
  promoModal,
  promoModalAction,
  removeModal,
  servicesMenu,
  successModal,
  tariffOptions,
  tariffFullPrice,
  tariffRenewalPrice,
  toPayment,
  toggleModal,
  walletAmountCalc,
} = useAccount();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(isAddonDetails) && _unref(isLoading))
      ? (_openBlock(), _createBlock(AccountSkeleton, { key: 0 }))
      : (_openBlock(), _createBlock(_Transition, {
          key: 1,
          name: "tab",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (!_unref(isAddonDetails))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("account.balance.title")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(walletAmountCalc)) + "₽", 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(BaseButton, {
                        title: _unref(t)('account.balance.topUp'),
                        size: "medium",
                        onClick: _unref(toPayment)
                      }, null, 8, ["title", "onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(TariffMain, {
                      options: _unref(tariffOptions),
                      nextDate: _unref(nextPaymentDate),
                      amount: _unref(tariffRenewalPrice),
                      "old-amount": _unref(tariffFullPrice),
                      "discount-percent": _unref(discountPercent),
                      "discount-name": _unref(discountName),
                      "period-label": _unref(pricePeriodLabel)
                    }, null, 8, ["options", "nextDate", "amount", "old-amount", "discount-percent", "discount-name", "period-label"])
                  ]),
                  _createVNode(_component_router_link, {
                    to: "/history",
                    class: "grid-block account-history"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(BaseFigureForIcon, {
                        class: "account-history--pic",
                        icon: "transactions",
                        color: "grey-secondary",
                        size: "large"
                      }),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("account.history.title")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(BaseFigureForIcon, {
                          icon: "more",
                          color: "grey-secondary",
                          size: "small",
                          "is-button": ""
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_unref(enabledOptions))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(AddonsMain, {
                          options: _unref(addonOptions),
                          onAction: _unref(openAddonDetails)
                        }, null, 8, ["options", "onAction"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("account.section.services")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(servicesMenu), (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "account-services__body-item",
                          onClick: ($event: any) => (_unref(router).push(item.link))
                        }, [
                          _createVNode(BaseFigureForIcon, {
                            icon: item.icon,
                            size: "extra-large",
                            color: "secondary"
                          }, null, 8, ["icon"]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("p", _hoisted_19, _toDisplayString(item.title), 1)
                          ])
                        ], 8, _hoisted_17))
                      }), 128))
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", {
                      class: "details-header--back",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddonDetails.value = false))
                    }, [
                      _createVNode(BaseFigureForIcon, {
                        size: "medium",
                        color: "white",
                        icon: "arrow",
                        position: "left",
                        "is-button": ""
                      })
                    ])
                  ]),
                  _createVNode(AddonsDetails, {
                    "chosen-addon": _unref(chosenAddon),
                    "is-active": true,
                    onAction: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleModal)(true, 'remove')))
                  }, null, 8, ["chosen-addon"])
                ]))
          ]),
          _: 1
        })),
    (_openBlock(), _createBlock(_Teleport, { to: ".root" }, [
      (_unref(removeModal))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            title: _unref(t)('account.modals.removeTitle'),
            "main-btn-title": _unref(t)('common.actions.no'),
            "secondary-btn-title": _unref(t)('common.actions.yes'),
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(toggleModal)(false, 'remove'))),
            onAction: _cache[3] || (_cache[3] = ($event: any) => (_unref(toggleModal)(false, 'remove'))),
            onSecondaryAction: _unref(disableAddon)
          }, null, 8, ["title", "main-btn-title", "secondary-btn-title", "onSecondaryAction"]))
        : _createCommentVNode("", true),
      (_unref(errorModal))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 1,
            title: _unref(t)('common.errors.title'),
            "main-btn-title": _unref(t)('account.modals.errorClose'),
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(toggleModal)(false, 'error'))),
            onAction: _cache[5] || (_cache[5] = ($event: any) => (_unref(toggleModal)(false, 'error')))
          }, null, 8, ["title", "main-btn-title"]))
        : _createCommentVNode("", true),
      (_unref(successModal))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 2,
            title: _unref(t)('account.modals.successTitle'),
            "main-btn-title": _unref(t)('common.actions.ok'),
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_unref(toggleModal)(false, 'success'))),
            onAction: _cache[7] || (_cache[7] = ($event: any) => (_unref(toggleModal)(false, 'success')))
          }, null, 8, ["title", "main-btn-title"]))
        : _createCommentVNode("", true),
      (_unref(promoModal))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 3,
            title: _unref(t)('account.modals.promoTitle'),
            "main-btn-title": _unref(t)('account.modals.promoAction'),
            onClose: _cache[8] || (_cache[8] = ($event: any) => (_unref(toggleModal)(false, 'promo'))),
            onAction: _unref(promoModalAction)
          }, null, 8, ["title", "main-btn-title", "onAction"]))
        : _createCommentVNode("", true),
      (_unref(feedbackResultModal))
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 4,
            title: 
        _unref(feedbackResult)
          ? _unref(t)('account.modals.feedbackThanksTitle')
          : _unref(t)('common.errors.title')
      ,
            text: 
        _unref(feedbackResult)
          ? _unref(t)('account.modals.feedbackThanksText')
          : _unref(t)('account.modals.feedbackErrorText')
      ,
            "main-btn-title": 
        _unref(feedbackResult)
          ? _unref(t)('account.modals.feedbackClose')
          : _unref(t)('account.modals.feedbackRetry')
      ,
            "is-success-modal": _unref(feedbackResult),
            onClose: _unref(closeFeedbackResultModal),
            onAction: _unref(closeFeedbackResultModal)
          }, null, 8, ["title", "text", "main-btn-title", "is-success-modal", "onClose", "onAction"]))
        : _createCommentVNode("", true),
      _createVNode(BaseFeedback, {
        modelValue: _unref(feedbackModal),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(feedbackModal) ? (feedbackModal).value = $event : null)),
        onSubmitResult: _unref(handleFeedbackSubmitResult)
      }, null, 8, ["modelValue", "onSubmitResult"])
    ]))
  ], 64))
}
}

})